const adminPanel = {
  adminPanel: {
    einAdmin: 'Amministrazione EIN',
    einInstallerSetup: 'Configurazione EIN Installer',
    installerDataUpdate: 'Aggiornamento dati Installer',
    uploadFile: 'Carica file',
    chooseFile: 'Scegli file',
    installerDataUpdateDescription: 'Quota di mercato di Enphase Installer, informazioni esclusive sugli sponsor, ecc.',
    header: 'Link barre del titolo',
    platinumTier: 'Livello Platinum',
    goldTier: 'Livello Gold',
    silverTier: 'Livello Silver',
    same: 'Uguale per tutti i livelli',
    bannerDescription: 'Descrizione banner',
    bannerLink: 'Link Banner',
    digitalAssets: 'Risorse digitali',
    name: 'Nome',
    file: 'File',
    access: 'Accedi alla categoria dei livelli',
    action: 'Azione',
    all: 'Tutti',
    platinum: 'Platinum',
    gold: 'Gold',
    silver: 'Silver',
    addDigital: 'Aggiungi risorsa digitale',
    productInformation: 'Informazioni sul prodotto',
    productName: 'Nome prodotto',
    learnMoreLink: 'Link Maggiori informazioni',
    featureName: 'Nome funzione A/B',
    featureType: 'Tipo funzione',
    betaRelease: 'Data versione beta',
    addProduct: 'Aggiungi informazioni sul prodotto',
    exclusiveUpdate: 'Link di aggiornamenti esclusivi',
    description: 'Descrizione',
    link: 'Link',
    addLink: 'Aggiungi link',
    one: '1.',
    two: '2.',
    installerList: 'Elenco di installatori per accesso al prodotto',
    usa: 'USA',
    // TODO - Start
    usa_pr: 'USA - Puerto Rico',
    france: 'France',
    // TODO - End
    australia: 'Australia',
    belgium: 'Belgio',
    netherlands: 'Paesi Bassi',
    germany: 'Germania',
    india: 'India',
    mexico: 'Messico',
    country: 'Nazione',
    fileName: 'Nome file',
    software_service: 'SOFTWARE_SERVICE',
    hardware_product: 'HARDWARE_PRODUCT',
    empty_file: 'Il file è vuoto',
    invalidFileFormat: 'Formato file non valido',
    invalidFileHeader: 'Intestazione file non valida',
    uploadFailed: 'Impossibile caricare il file',
    invalidFile: 'File non valido',
    errorDetail: {
      one: '%{errorCount} su %{count} riga non riuscita.',
      other: '%{errorCount} su %{count} righe non riuscite.'
    },
    viewError: 'Visualizza errori',
    errorListText: 'Elenco errori caricamento file',
    companyId: 'ID azienda',
    message: 'Messaggio',
    sampleFileName: 'File di esempio'
  }
};

export default adminPanel;
